<template>
  <v-card-text>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "signature-options",
  mixins: [ options ]
}
</script>
<style>
</style>
